import { cubicOut } from 'svelte/easing';

export function slide(node, { delay = 0, duration = 400, easing = cubicOut }) {
  const style = getComputedStyle(node);
  const width = parseFloat(style.width);

  return {
    delay,
    duration,
    easing,
    css: (t) =>
      `
      overflow: hidden;
      width: ${t * width}px;`,
  };
}
